
var sprite = require("/Users/fizz/side/antd-mobile/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 30 2\" id=\"minus\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <!-- Generator: Sketch 42 (36781) - http://www.bohemiancoding.com/sketch --> <title>Rectangle</title> <desc>Created with Sketch.</desc> <defs/> <g id=\"minus_Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"> <rect id=\"minus_Rectangle\" fill=\"#000000\" x=\"0\" y=\"0\" width=\"30\" height=\"2\"/> </g> </symbol>";
module.exports = sprite.add(image, "minus");


/*****************
 ** WEBPACK FOOTER
 ** ./components/stepper/style/assets/minus.svg
 ** module id = 482
 ** module chunks = 0
 **/